import React from "react";
import PageNavbar from "@insightfulscience/atomic-react/PageNavbar";
import PageNavbarItem from "@insightfulscience/atomic-react/PageNavbar/Item";
import Dropdown from "@insightfulscience/atomic-react/Dropdown";
import DropdownMenu from "@insightfulscience/atomic-react/Dropdown/Menu";
import DropdownMenuItem from "@insightfulscience/atomic-react/Dropdown/MenuItem";
import { arrayOf, shape, string } from "prop-types";

const Menu = ({ items = [] }) => {
	return (
		items.length > 0 && (
			<PageNavbar bgColor="white">
				{items.map(item => (
					<PageNavbarItem key={item.id}>
						<Dropdown utility={{ display: "block" }} sx={{ textAlign: "center" }}>
							<Dropdown.Title
								triangleProps={{ color: "3", isOpenColor: "3" }}
								sx={{ textAlign: "center", fontWeight: "bold", fontSize: "m" }}
								utility={{ display: "flex", justify: "center" }}
								spacing={{ py: 2 }}
								className="navbar-item-b-line"
							>
								{item.title}
							</Dropdown.Title>
							<Dropdown.Body align="full">
								<DropdownMenu>
									{(item.items || []).map(({ id, title }) => (
										<DropdownMenuItem key={id}>
											<DropdownMenuItem.Link href={`#${id}`}>{title}</DropdownMenuItem.Link>
										</DropdownMenuItem>
									))}
								</DropdownMenu>
							</Dropdown.Body>
						</Dropdown>
					</PageNavbarItem>
				))}
			</PageNavbar>
		)
	);
};

Menu.propTypes = {
	items: arrayOf(
		shape({
			id: string,
			title: string,
			items: arrayOf(
				shape({
					id: string,
					title: string,
				}),
			),
		}),
	),
};

export default Menu;
